import React from 'react';
import logo from './logo.svg';
import './App.css';
import "./css/bootstrap.min.css";
import "./css/animate.min.css";
import "./css/style.css";
import "./css/responsive.css";
import "./css/light-color.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter as Router, Route, Link, useParams, Routes } from 'react-router-dom';
import EvtHub from './eventhub';
import EvtHome from './eventhome';
import PageNotFound from './components/sections/PageNotFound';
import AdminHome from './adminhome';
import { createBrowserRouter,RouterProvider } from 'react-router-dom'
import { AuthContext } from './components/admin/authcontext';
import { AddEvent } from './components/admin/addevent';
import firebaseconfig from './firebaseappconfig.json';
import { initializeApp } from 'firebase/app';
import { AdminMenu } from './components/admin/adminmenu';
import { ProtectedRoute } from './components/admin/protectedroute';
import { AddSpeaker } from './components/admin/addspeakers';
import Modal from 'react-modal';
import ManageSchedule from './components/admin/manageschedule';
import { ManageSponsors } from './components/admin/managesponsor';
import { ManagePartners } from './components/admin/managepartners';
import { ManageCoupons } from './components/admin/managecoupon';
import { ManageNews } from './components/admin/managenews';
import { Reports } from './components/admin/reports';
import ReportsTransactionGrp from './components/admin/reportstransactionsgrp';
import ReportsTransaction from './components/admin/reportstransactions';
import CheckinComponent from './components/eventhub/checkincomponent';
import { TemplateManager } from './components/admin/TemplateManager';
import { AdditionalPageManager } from './components/admin/AdditionalPageManager';
import { ManageTestimonials } from './components/admin/managetestimonials';
import { ManageAwards } from './components/admin/manageawards';
import { ManageAwardJury } from './components/admin/manageawardjury';
import  EvtRegister  from './pages/evtregister';
import EvtSchedule from './pages/evtschedules';
import EvtSpeakers from './pages/evtspeakers';
import EvtSponsors from './pages/evtsponsors';
import EvtAwards from './pages/evtawards';
import EvtPartners from './pages/evtpartners';
import EvtLocation from './pages/evtlocation';
import EvtContact from './pages/evtcontact';
import MainWebsitePage from './components/sections/mainwebsite/MainWebsitePage';
import MemberRegister from './pages/mainwebsite/memberregister';
import Contact from './pages/mainwebsite/contact';
import CodeOfConduct from './pages/mainwebsite/codeofconduct';
import TeamMembers from './pages/mainwebsite/teammembers';
import AboutUs from './pages/mainwebsite/aboutus';
import PrivacyPolicy from './pages/mainwebsite/privacypolicy';
import Cfp from './pages/mainwebsite/cfp';
import Blogs from './pages/mainwebsite/blogs';
import Gallery from './pages/mainwebsite/gallery';
import { ManageBlogs } from './components/admin/manageblogs';
import { ManageGallery } from './components/admin/managegallery';
import { ManageAudienceExperience } from './components/admin/manageaudienceexperience';
import { ManageMediaCoverage } from './components/admin/managemediacoverage';
import BlogDetail from './pages/mainwebsite/blogdetail';
import EvtEmergex from './pages/evtemergex';
import { EventPageContent } from './components/sections/EventPageContent';

function App() {
  const app = initializeApp(firebaseconfig);
  Modal.setAppElement('#root');
  return (
    <>
     <AuthContext>
     <Router>
    <Routes>
  <Route path="/" Component={MainWebsitePage} />
  <Route path="/contact" Component={Contact} />
  <Route path="/codeofconduct" Component={CodeOfConduct} />
  <Route path="/teammembers" Component={TeamMembers} />
  <Route path="/aboutus" Component={AboutUs} />
  <Route path="/cfp" Component={Cfp} />
  <Route path="/blogs" Component={Blogs} />
  <Route path="/blogdetails" Component={BlogDetail} />
  <Route path="/gallery" Component={Gallery} />
  <Route path="/registermember" Component={MemberRegister} />
  <Route path="/privacypolicy" Component={PrivacyPolicy} />
  <Route path="/event/attending/:eventcode" Component={EvtHub} />
  <Route path="/event/checkin/:eventcode/:checkinkey/:checkinfield" Component={CheckinComponent} />
  <Route path="/event/:eventcode/register" Component={EvtRegister} />
  <Route path="/event/:eventcode/speakers" Component={EvtSpeakers} />
  <Route path="/event/:eventcode/schedule" Component={EvtSchedule} />
  <Route path="/event/:eventcode/sponsors" Component={EvtSponsors} />
  <Route path="/event/:eventcode/awards" Component={EvtAwards} />
  <Route path="/event/:eventcode/partners" Component={EvtPartners} />
  <Route path="/event/:eventcode/location" Component={EvtLocation} />
  <Route path="/event/:eventcode/contact" Component={EvtContact} />
  <Route path="/event/:eventcode/emergex" Component={EvtEmergex} />
  <Route path="/event/:eventcode/page/:pagename" Component={EventPageContent} />
  <Route path="/event/:eventcode" Component={EvtHome} />
  <Route path="/event" Component={EvtHome} />
  <Route path="/pagenotfound" Component={PageNotFound} />
  <Route path='/weba' element={ <ProtectedRoute roles={['ADMIN','SCHEDULE_OPERATOR']}>  <AddEvent/>  </ProtectedRoute>}  />
  <Route path='/weba/manageevent' element={ <ProtectedRoute roles={['ADMIN','SCHEDULE_OPERATOR']}>  <AddEvent/>  </ProtectedRoute>}  />
  <Route path='/weba/managespeakers/:eventcode' element={ <ProtectedRoute roles={['ADMIN','SCHEDULE_OPERATOR']}>  <AddSpeaker/>  </ProtectedRoute>}  />
  <Route path='/weba/managesponsors/:eventcode' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageSponsors/>  </ProtectedRoute>}  />
  <Route path='/weba/managepartners/:eventcode' element={ <ProtectedRoute roles={['ADMIN']}>  <ManagePartners/>  </ProtectedRoute>}  />
  <Route path='/weba/managenews' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageNews/>  </ProtectedRoute>}  />
  <Route path='/weba/manageblogs' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageBlogs/>  </ProtectedRoute>}  />
  <Route path='/weba/managegallery' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageGallery/>  </ProtectedRoute>}  />
  <Route path='/weba/manageaudienceexperience' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageAudienceExperience/>  </ProtectedRoute>}  />
  <Route path='/weba/manageschedule/:eventcode' element={ <ProtectedRoute roles={['ADMIN','SCHEDULE_OPERATOR']}>  <ManageSchedule/>  </ProtectedRoute>}  />
  <Route path='/weba/managecoupons/:eventcode' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageCoupons/>  </ProtectedRoute>}  />
  <Route path='/weba/managereports/:eventcode' element={ <ProtectedRoute roles={['ADMIN']}>  <Reports/>  </ProtectedRoute>}  />
  <Route path='/weba/managetransactions/:eventcode' element={ <ProtectedRoute roles={['ADMIN']}>  <ReportsTransaction/>  </ProtectedRoute>}  />
  <Route path='/weba/managegrppay/:eventcode' element={ <ProtectedRoute roles={['ADMIN']}>  <ReportsTransactionGrp/>  </ProtectedRoute>}  />
  <Route path='/weba/managetemplates' element={ <ProtectedRoute roles={['ADMIN']}>  <TemplateManager/>  </ProtectedRoute>}  />
  <Route path='/weba/managetestimonials' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageTestimonials/>  </ProtectedRoute>}  />
  <Route path='/weba/managepages/:eventcode' element={ <ProtectedRoute roles={['ADMIN']}>  <AdditionalPageManager/>  </ProtectedRoute>}  />
  <Route path='/weba/manageawards/:eventcode' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageAwards/>  </ProtectedRoute>}  />
  <Route path='/weba/manageawardjury/:eventcode' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageAwardJury/>  </ProtectedRoute>}  />
  <Route path='/weba/managemediacoverage' element={ <ProtectedRoute roles={['ADMIN']}>  <ManageMediaCoverage/>  </ProtectedRoute>}  />
  <Route path='/weba/home' element={ <ProtectedRoute roles={['ADMIN','SCHEDULE_OPERATOR']}>  </ProtectedRoute>}  />
  <Route path="/weba/signin" Component={AdminHome} />
  </Routes>
    </Router>
    </AuthContext>
  <div className="App">
  </div>
  </>
  );
}

export default App;
